<template>
  <div>
    <a-card v-if="selectEnable" :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" >
          <a-row :gutter="16">
            <a-col :span="6">
              <a-form-item label="企业名称">
                <a-input  v-model="queryParam.enterpriseName" />
              </a-form-item>
              <a-form-item label="安装类别">
                <!--<a-select  :allowClear="true" :options="installTypeMap" v-model="queryParam.installType"></a-select>-->
                <a-select  v-model="queryParam.installType" :allowClear="true">
                  <a-select-option  v-for="type in installTypeMap" :title="type.label" :key="type.value">{{type.label}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="付款方式">
                <!--<a-select  :options="payTypeMap" v-model="queryParam.paymentMethod"></a-select>-->
                <a-select  v-model="queryParam.paymentMethod" :allowClear="true">
                  <a-select-option  v-for="type in payTypeMap" :title="type.label" :key="type.value">{{type.label}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="企业星级">
                <!--<a-select  :options="enterpriseLevelMap" v-model="queryParam.enterpriseStar" />-->
                <a-select  v-model="queryParam.enterpriseStar" :allowClear="true">
                  <a-select-option  v-for="type in enterpriseLevelMap" :title="type.label" :key="type.value">{{type.label}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="注册人" v-if="isShow == 1" style="margin-left: 14px">
                <a-input  v-model="queryParam.operBy"/>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="企业联系人">
                <a-input  v-model="queryParam.enterpriseContacter"/>
              </a-form-item>
              <a-form-item label="企业状态" style="margin-left: 14px">
                <!--<a-select   :options="enterpriseStatusMap" v-model="queryParam.status"></a-select>-->
                <a-select  v-model="queryParam.status" :allowClear="true">
                  <a-select-option  v-for="type in enterpriseStatusMap" :title="type.label" :key="type.value">{{type.label}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="结算周期" style="margin-left: 14px">
                <!--<a-select  :allowClear="true" :options="settleCycleMap" v-model="queryParam.settlementCycle"></a-select>-->
                <a-select  v-model="queryParam.settlementCycle" :allowClear="true">
                  <a-select-option  v-for="type in settleCycleMap" :title="type.label" :key="type.value">{{type.label}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="企业开票" style="margin-left: 14px">
                <a-select  :allowClear="true" v-model="queryParam.hasInvoice">
                  <a-select-option value="1" title="是">
                    是
                  </a-select-option>
                  <a-select-option value="0" title="否">
                    否
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="企业联系方式">
                <a-input  v-model="queryParam.enterpriseContactInfo"/>
              </a-form-item>
              <a-form-item label="企业下单" style="margin-left: 28px">
                <!--<a-select  :allowClear="true" :options="importanceTypeMap" v-model="queryParam.enterpriseOrderLevel"></a-select>-->
                <a-select  v-model="queryParam.enterpriseOrderLevel" :allowClear="true">
                  <a-select-option  v-for="type in importanceTypeMap" :title="type.label" :key="type.value">{{type.label}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-row :gutter="8">
                <a-col :span="8">
                  <a-select :allowClear="true" v-model="queryParam.timeType1">
                    <a-select-option value="auditTime" title="审核时间">
                      审核时间
                    </a-select-option>
                    <a-select-option value="orderTime" title="下单时间">
                      下单时间
                    </a-select-option>
                    <a-select-option value="contractStartTime" title="合同开始时间">
                      合同开始时间
                    </a-select-option>
                    <a-select-option value="contractEndTime" title="合同结束时间">
                      合同结束时间
                    </a-select-option>
                    <a-select-option value="createTime" title="注册时间">
                      注册时间
                    </a-select-option>
                  </a-select>
                </a-col>
                <a-col :span="16">
                  <a-range-picker @change="onChangeTime1" v-model="queryParam.time1" />
                </a-col>
              </a-row>
              <a-form-item style="margin-top: 24px;margin-left: 28px" label="短信提示">
                <a-select  :allowClear="true" v-model="queryParam.hasSms">
                  <a-select-option value="1" title="是">
                    是
                  </a-select-option>
                  <a-select-option value="0" title="否">
                    否
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="市场负责人">
                <a-input  v-model="queryParam.marketPrincipal"/>
              </a-form-item>
              <a-form-item label="审核人" style="margin-left: 28px">
                <a-input  v-model="queryParam.auditBy"/>
              </a-form-item>
              <a-row :gutter="8">
                <a-col :span="8">
                  <a-select :allowClear="true" v-model="queryParam.timeType2">
                    <a-select-option value="auditTime" title="审核时间">
                      审核时间
                    </a-select-option>
                    <a-select-option value="orderTime" title="下单时间">
                      下单时间
                    </a-select-option>
                    <a-select-option value="contractStartTime" title="合同开始时间">
                      合同开始时间
                    </a-select-option>
                    <a-select-option value="contractEndTime" title="合同结束时间">
                      合同结束时间
                    </a-select-option>
                    <a-select-option value="createTime" title="注册时间">
                      注册时间
                    </a-select-option>
                  </a-select>
                </a-col>
                <a-col :span="16">
                  <a-range-picker @change="onChangeTime2" v-model="queryParam.time2" />
                </a-col>
              </a-row>
              <a-form-item label="合同文件" style="margin-top: 24px;margin-left: 14px">
                <a-select  :allowClear="true" v-model="queryParam.hasContract">
                  <a-select-option value="1" title="是">
                    是
                  </a-select-option>
                  <a-select-option value="0" title="否">
                    否
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row style="margin-bottom: 20px">
            <a-col :span="3" :offset="11">
              <span v-if="isShow == 0" style="cursor:pointer" @click="getMore"><a-icon type="down-circle" theme="twoTone" style="fontSize:24px"/></span>
              <!--<a-divider type="vertical" />-->
              <span v-if="isShow == 1" style="cursor:pointer" @click="hiddenMore"><a-icon type="up-circle" theme="twoTone" style="fontSize:24px"/></span>
            </a-col>
            <a-col :span="5" :offset="5" style="text-align: right">
              <a-button htmlType="submit" type="primary"  @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">清空</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <s-table
        size="default"
        ref="table"
        rowKey="enterpriseBlackListId"
        :columns="columns"
        :data="loadData"
        :scroll="{ x: 2500 }"
        bordered
      >
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record.enterpriseId)">查看</a>
        <a-divider type="vertical" />
        <a @click="restoreEnterprise(record.enterpriseId)">恢复</a>
      </span>
      </s-table>
      <enterprise-details ref="details" @ok="handleOk" />
    </a-card>
    <no-authority v-if="!selectEnable"></no-authority>
  </div>

</template>

<script>
import { STable } from '@/components'
import { getEnterpriseManagement } from '@/api/enterprise/management'
import { enterpriseListresume } from '@/api/enterprise/enterprise'
import EnterpriseDetails from './EnterpriseDetails'
import NoAuthority from './NoAuthority'
import { checkPermission } from '@/utils/permissions'
import { getDictMap } from '../../utils/dict'
import {selectFindAll} from '@/api/enterprise/enterprise'

export default {
  name: 'TableList',
  components: {
    STable,
    EnterpriseDetails,
    NoAuthority
  },
  data () {
    return {
      form: this.$form.createForm(this),
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: 'rowNum',
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center'
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseFullName',
          align: 'center'
        },
        {
          title: '企业简称',
          dataIndex: 'enterpriseSimpleName',
          align: 'center'
        },
        {
          title: '企业联系人',
          dataIndex: 'enterpriseContacter',
          align: 'center'
        },
        {
          title: '市场负责人',
          dataIndex: 'marketPrincipal',
          align: 'center'
        },
        {
          title: '安装类别',
          dataIndex: 'installType',
          align: 'center'
        },
        {
          title: '总单量',
          dataIndex: 'totalOrderCount',
          align: 'center'
        },
        {
          title: '企业星级',
          dataIndex: 'enterpriseStar',
          align: 'center'
        },
        {
          title: '付款方式',
          dataIndex: 'paymentMethod',
          align: 'center'
        },
        {
          title: '结算周期',
          dataIndex: 'settlementCycle',
          align: 'center'
        },
        {
          title: '合同文件',
          dataIndex: 'hasContract',
          align: 'center'
        },
        {
          title: '合同有效期',
          dataIndex: 'contractDuration',
          align: 'center'
        },
        {
          title: '审核时间',
          dataIndex: 'auditTime',
          align: 'center'
        },
        {
          title: '审核人',
          dataIndex: 'auditBy',
          align: 'center'
        },
        {
          title: '注册时间',
          dataIndex: 'createTime',
          align: 'center'
        },
        {
          title: '注册人',
          dataIndex: 'createUserName',
          align: 'center'
        },
        {
          title: '操作时间',
          dataIndex: 'operTime',
          align: 'center'
        },
        {
          title: '操作人',
          dataIndex: 'operBy',
          align: 'center'
        },
        {
          title: '拉黑备注',
          dataIndex: 'reason',
          align: 'center'
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getEnterpriseManagement(Object.assign(parameter, this.queryParam))
      },
      isShow:0,
      installTypeMap: [],
      payTypeMap: [],
      enterpriseLevelMap: [],
      settleCycleMap: [],
      enterpriseStatusMap: [],
      importanceTypeMap: [],
      selectEnable: checkPermission('enterprise:enterpriseBlackList:select'),
      // editEnabel: checkPermission('enterprise:enterpriseBlackList:edit'),
      // removeEnable: checkPermission('enterprise:enterpriseBlackList:remove')
    }
  },
  filters: {
  },
  async created () {
    // document.body.addEventListener('keyup', e => {
    //   if (e.keyCode == 13) {
    //     this.$refs.table.refresh(true)
    //   }
    // })
    selectFindAll({dictTypes:'install_type,pay_type,enterprise_level,settle_cycle,enterprise_status,enterprise_importance_type'}).then(res=>{
      // 安装类别
      this.installTypeArr = res.install_type
      this.installTypeArr.forEach((value, key) => {
        this.installTypeMap.push({ value: value.dictValue, label: value.dictLabel })
      })

      // 付款方式
      this.payTypeArr = res.pay_type
      this.payTypeArr.forEach((value, key) => {
        this.payTypeMap.push(
          { value: value.dictValue, label: value.dictLabel }
        )
      })

      // 企业星级
      this.enterpriseLevelArr = res.enterprise_level
      this.enterpriseLevelArr.forEach((value, key) => {
        this.enterpriseLevelMap.push(
          { value: value.dictValue, label: value.dictLabel }
        )
      })

      // 结算周期
      this.settleCycleArr =res.settle_cycle
      this.settleCycleArr.forEach((value, key) => {
        this.settleCycleMap.push(
          { value: value.dictValue, label: value.dictLabel }
        )
      })

      // 企业状态
      this.enterpriseStatusArr = res.enterprise_status
      this.enterpriseStatusArr.forEach((value, key) => {
        this.enterpriseStatusMap.push(
          { value: value.dictValue, label: value.dictLabel }
        )
      })

      // 重要程度
      this.importanceTypeArr = res.enterprise_importance_type
      this.importanceTypeArr.forEach((value, key) => {
        this.importanceTypeMap.push(
          { value: value.dictValue, label: value.dictLabel }
        )
      })
    })

  },
  methods: {
    // 更多、隐藏
    getMore(){
      this.isShow = 1
    },
    hiddenMore(){
      this.isShow = 0
    },
    onChangeTime1 (date) {
      if (date) {
        this.queryParam.timeBegin1 = date[0].format('YYYY-MM-DD HH:mm:ss')
        this.queryParam.timeEnd1 = date[1].format('YYYY-MM-DD HH:mm:ss')
      }
    },
    onChangeTime2 (date) {
      if (date) {
        this.queryParam.timeBegin2 = date[0].format('YYYY-MM-DD HH:mm:ss')
        this.queryParam.timeEnd2 = date[1].format('YYYY-MM-DD HH:mm:ss')
      }
    },
    handleAdd () {
      this.$refs.modal.add()
    },
    handleEdit (enterpriseId) {
      this.$refs.details.edit(enterpriseId,'1',0)
    },
    handleOk () {
      this.$refs.table.refresh(true)
      console.log('handleSaveOk')
    },
    restoreEnterprise (enterpriseId) {
      enterpriseListresume({ 'enterpriseId': enterpriseId }).then(res => {
        console.log(res)
        if (res.code === 0) {
          this.$message.success('恢复成功')
          this.handleOk()
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  }
}
</script>
<style scoped>
  .twobtn{
    width: 110px;
    font-size: 15px;
  }
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { white-space: nowrap; padding: 4px 16px !important;}
</style>
